"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _polished = require("polished");

var _Wrapper = _interopRequireDefault(require("../elements/Wrapper"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _StyledWrapper = (0, _styledComponents["default"])(_Wrapper["default"]).withConfig({
  displayName: "Input___StyledWrapper",
  componentId: "f7s8y6-0"
})(["&&{border:1px solid ", ";line-height:1;outline:none;text-overflow:ellipsis;transition:0.2s ", ";white-space:nowrap;&:hover{border-color:", ";}&:active,&:focus{border:2px solid ", ";}", ";}"], function (p) {
  return p._css;
}, _styles.easing, _styles.black, _styles.primary, function (p) {
  return p._css2;
});

function Input(_ref) {
  var cssProp = _ref.css,
      props = _objectWithoutProperties(_ref, ["css"]);

  return /*#__PURE__*/_react["default"].createElement(_StyledWrapper, _extends({
    component: 'input',
    borderRadius: _styles.borderRadius,
    py: 18.5,
    px: 14,
    fontSize: _styles.fontSizes.body,
    type: 'text'
  }, props, {
    _css: (0, _polished.transparentize)(0.75, _styles.black),
    _css2: cssProp
  }));
}

var _default = Input;
exports["default"] = _default;